import { Link} from 'react-router-dom';

function Footer() {
    return (
        <div>
        <footer id="footer" className="footer">   
    <div className="footer-newsletter">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12 text-center">
            <h4><i className="bi bi-folder-symlink" style={{color: '#f4403f'}}></i>&nbsp;Newsletter</h4>
            <p>Welcome to my newsletter, where I am bring you the latest updates, offers, and discounts in website design and developent. </p>
          </div>
          <div className="col-lg-6">
            <form action="https://www.pankj.com/php/newsletter.php" method="post">
          <input type="text" className="hiddenclasss" name="title" />
        <input type="email" name="email" minLength="10" maxLength="30" placeholder="Email Address" required />
      <input type="submit" name="submit" placeholder="Submit" value=" Follow Me" onclick="return SubmitDetails();" />
            </form>
          </div>
        </div>
      </div>
    </div>
<div className="footer-top">
<div className="container">
<div className="row gy-4">
<div className="col-lg-3 col-md-12 footer-info">
<Link to="index.html" className="logo d-flex align-items-center">
<img src="assets/img/logo.png" alt="Website Designing Company In Gurgaon" /><span></span></Link><p>
  I am Pankaj Kumar Singh, a website designer and developer with 10+ years of experience. Since 2013, I have completed 500+ website projects and provide professional website design, development, and SEO services across Gurgaon and India.
</p><div className="social-links mt-3">
<a href="https://x.com/pankjweb" target="_blank" className="twitter"><i className="bi bi-twitter-x"></i></a>
<a href="https://www.facebook.com/pankjweb" target="_blank" className="facebook"><i className="bi bi-facebook"></i></a>
<a href="https://www.instagram.com/pankjweb" target="_blank" className="instagram"><i className="bi bi-instagram"></i></a>
<a href="https://www.threads.net/pankjweb" target="_blank" className="threads"><i className="bi bi-threads"></i></a>

<a href="https://www.linkedin.com/in/pankjweb" target="_blank" className="linkedin"><i className="bi bi-linkedin"></i></a>
<a href="https://in.pinterest.com/pankjweb" target="_blank" className="pinterest"><i className="bi bi-pinterest"></i></a>
<a href="https://whatsapp.com/channel/0029VaoeHx3KmCPOqD4cLt3Q" target="_blank"><i className="bi bi-whatsapp" aria-hidden="true"></i></a>
</div>
</div>
<div className="col-lg-2 col-6 footer-links">
<h4>Quick Link</h4>
<ul>
<li><i className="bi bi-chevron-right"></i> <Link to="/">Home</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="about-me">About Me</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="services">Services</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="portfolios">Portfolio</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="certificate">Certificate</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="contact">Contact</Link></li>
</ul>
</div>
<div className="col-lg-2 col-6 footer-links">
<h4>Useful Links</h4>
<ul>
<li><i className="bi bi-chevron-right"></i> <a href="https://www.fiverr.com/pankajsingh642" target="_blank">Fiverr.com</a></li>
<li><i className="bi bi-chevron-right"></i> <a href="https://www.freelancer.in/u/pankajsingh642">Freelancer.com</a></li>
<li><i className="bi bi-chevron-right"></i>  <Link to="privacy-policy">Privacy Policy</Link></li>
<li><i className="bi bi-chevron-right"></i>  <Link to="refund-policy">Refund Policy</Link></li>
<li><i className="bi bi-chevron-right"></i>  <Link to="terms-and-conditions">Terms & Conditions</Link></li>
<li><i className="bi bi-chevron-right"></i>  <Link to="disclaimer">Disclaimer</Link></li>
</ul>
</div>
<div className="col-lg-2 col-6 footer-links">
<h4>My Services</h4>
<ul>
<li><i className="bi bi-chevron-right"></i> <Link to="graphic-designer-in-gurgaon">Graphic Design</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="web-designer-in-gurgaon">Web Design</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="web-developer-in-gurgaon">Web Development</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="freelance-seo-services-in-gurugram">SEO Services</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="ppc-services-in-gurgaon">PPC Services</Link></li>
<li><i className="bi bi-chevron-right"></i> <Link to="social-media-marketing-freelancers-in-gurugram">Social Media Marketing</Link></li>

</ul>
</div>
<div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
<h4>Collaborate. Create. Connect</h4>
<p><i className="bi bi-geo-alt-fill"></i> :  
49/50 Nathupur, Road No. 59,
Gurugram, Hr – 122002, India
<br/>
<br/>
<strong><i className="bi bi-earbuds"></i> : </strong> <a href="tel:+917838704822" target="_blank">+91-7838704822</a><br/>
<strong><i className="bi bi-envelope-open-fill"></i> : </strong><a href="mailto:info@pankj.com" target="_blank">info@pankj.com</a><br/>
<strong><i className="bi bi-envelope-open-fill"></i> : </strong><a href="mailto:csepksingh@gmail.com" target="_blank">csepksingh@gmail.com</a><br/>
</p>
</div>
</div>
</div>
</div>
<div className="container">
  <div className="copyright">
    &copy; 2013-2026 
    <strong>
      <span> Pankaj Kumar Singh (pankj.com)</span>
    </strong>. 
    All Rights Reserved.<br/>
  </div>
</div>
  </footer>
  <Link to="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></Link>
        </div>
        
    );
}
export default Footer;
